import styled from 'styled-components';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';

export const Container = styled.div`
  margin-top: 24px;
  height: 100px;
`;

export const DriverName = styled.p`
  font-size: ${pxToRem(16)};
  font-weight: 300;
  line-height: 1.25;
  margin: ${props => (props.isAssigned && props.showPhone ? '18px 0 4px 0' : '30px 0 4px 0')};
  text-transform: ${props => (props.isAssigned ? 'capitalize' : 'initial')};
`;

DriverName.defaultProps = {
  isAssigned: true,
};

export const ImgWrapper = styled.div`
  float: left;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin: 8px 16px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    ${props => (props.hasQuiqee ? 'max-width: 30px;' : 'width: 48px; height: 48px; border-radius: 50%;')};
  }
`;

export const Label = styled.p`
  font-size: ${pxToRem(12)};
  text-transform: uppercase;
  font-weight: 300;
  line-height: 1.3;
  margin: 0 0 7px 0;
  color: ${props => props.theme.sky500};
`;



// WEBPACK FOOTER //
// ./src/app/order-card/driver-card/styles.js